import React from 'react';
import { useTranslation } from '~/Locale';
import PrivateRegistrationForm from './Form';
import { Button, Flex } from '@kvdbil/components';
import styled from 'styled-components';
import { RegistrationView } from '../../types';

const ButtonWrapper = styled(Flex)`
  margin-top: 2rem;
`;

type Props = {
  changeView: (view: RegistrationView) => void;
};

export const PrivateRegistrationView = ({ changeView }: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <PrivateRegistrationForm onSuccess={() => changeView('COMPLETED')} />

      <ButtonWrapper>
        <Button
          onClick={() => changeView('CREATE_ACCOUNT')}
          variant="flat"
          color="neutral"
        >
          {t('I want to use BankID instead')}
        </Button>
      </ButtonWrapper>
    </div>
  );
};

export default PrivateRegistrationView;
